var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container", attrs: { id: "category-edit" } },
    [
      _c(
        "div",
        { staticClass: "content" },
        [
          _c(
            "el-form",
            {
              ref: "searchForm",
              attrs: { inline: true, id: "searchForm", model: _vm.searchForm },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "类目", prop: "categoryId" } },
                [
                  _c("el-cascader", {
                    attrs: {
                      "popper-class": "search-category",
                      placeholder: "请输入商品类目",
                      options: _vm.categoryList,
                      "show-all-levels": true,
                      size: "mini",
                      filterable: "",
                      clearable: "",
                    },
                    on: { change: _vm.onChangeCategory },
                    model: {
                      value: _vm.categoryId,
                      callback: function ($$v) {
                        _vm.categoryId = $$v
                      },
                      expression: "categoryId",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c("h3", [_vm._v("选择商品分类")]),
          _vm.categoryId && _vm.categoryId.length !== 0
            ? _c(
                "div",
                { staticClass: "show-category", attrs: { title: "展示" } },
                [
                  _c("span", [_vm._v("已选择：")]),
                  _c("el-cascader", {
                    attrs: {
                      options: _vm.categoryList,
                      disabled: true,
                      separator: " > ",
                    },
                    model: {
                      value: _vm.categoryId,
                      callback: function ($$v) {
                        _vm.categoryId = $$v
                      },
                      expression: "categoryId",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _c("el-cascader-panel", {
            attrs: { options: _vm.categoryList },
            model: {
              value: _vm.categoryId,
              callback: function ($$v) {
                _vm.categoryId = $$v
              },
              expression: "categoryId",
            },
          }),
          _c(
            "span",
            {
              staticStyle: {
                float: "right",
                "margin-top": "20px",
                "margin-bottom": "20px",
              },
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.isChange()
                    },
                  },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }